<template>
  <div v-element-loader="{ endpoint: 'getCart' }" class="main main__container">
    <h1 class="container__header">
      {{ t('cartPageHeadline') }}
    </h1>

    <p class="block__text block__text--margin">
      <template v-if="cart.totalPrice > 0">
        {{ t('cartPageText') }}
      </template>

      <template v-else>
        <div v-html="t('checkoutTextNoDataInCart')">
        </div>
      </template>
    </p>

    <oie-cart-shell-container></oie-cart-shell-container>
  </div>
</template>

<script>
import gtm from '@/core/enhanced-ecommerce-gtm'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    cartLoaded: false,
    initialListViewSelection: null
  }),
  computed: {
    ...mapGetters('commerce', ['cartSelectedRows', 'cart']),
    ...mapGetters('ui', ['useListView']),
    ...mapGetters(['enableGtm'])
  },
  watch: {
    cart: function(value) {
      this.sendGtmEvent(value)
    }
  },
  mounted() {
    this.sendGtmEvent(this.cart)

    this.initialListViewSelection = this.useListView
    this.toggleValue({ key: 'useListView', data: true })
    window.addEventListener('beforeunload', () => {
      this.toggleValue({ key: 'useListView', data: this.initialListViewSelection })
    })
  },
  methods: {
    ...mapActions('ui', ['toggleValue']),
    sendGtmEvent(cart) {
      if (cart.rows !== undefined && this.enableGtm && !this.cartLoaded) {
        gtm.addCheckoutStep('view_cart', cart)
        this.cartLoaded = true
      }
    }
  }
}
</script>

<style lang="scss">
.cart-container__back-link {
  @include body-semi-bold;
  display: flex;
  align-items: center;
  color: color(text-blue);
  text-decoration: none;
  margin-bottom: measure(full);

  &:hover {
    text-decoration: underline;
  }

  @include media(medium) {
    @include h3-semi-bold;
  }

  @media print {
    display: none;
  }
}

.cart-summary {
  display: flex;
  align-items: center;
  margin-top: measure(half);
}

.cart-summary__total-sum {
  @include h3-semi-bold;
  margin-left: auto;
}
</style>
